import {Component} from 'react';

class AwardCountsByPlayer extends Component {
  constructor(props) {
    super(props);
    this.state={
   
    }   
    this.medalTypes = ["Badge", "Bronze", "Silver", "Gold", "Jewel", "ExtraCredit"];
    this.processAwardArr();
}

// user --> awardArr {awardType: xxxxx,  awardCount: 9999}  ==>  
processAwardArr(){
     this.outputCounts = [0, 0, 0, 0, 0, 0];
     for (let i=0; i<this.props.awards.awardArr.length; i++){
          const medalType = this.props.awards.awardArr[i].awardType;
          const medalIndx = this.medalTypes.indexOf(medalType);
          this.outputCounts[medalIndx] += this.props.awards.awardArr[i].awardCount;
     }
}
  
render() {
          
return <>
      <tr>
          {this.props.awards.user === "Maximum Number"  ?
                  <td className="text-left font-weight-bold"
                    onClick ={()=> this.props.playerAwardDetail(this.props.awards.user)}>   
                    {this.props.awards.user}
               </td>
          :
               <td className="text-left font-weight-bold text-primary text-pointer"
                    onClick ={()=> this.props.playerAwardDetail(this.props.awards.user)}>   
                    <u>{this.props.awards.user}</u>
               </td>
          }
          <td className="text-center" >
               {this.outputCounts[0]}
          </td>
          <td className="text-center" >
               {this.outputCounts[1]}
          </td>
          <td className="text-center" >
               {this.outputCounts[2]}
          </td>
          <td className="text-center" >
               {this.outputCounts[3]}
          </td>
          <td className="text-center" >
               {this.outputCounts[4]}
          </td>
          <td className="text-center" >
               {this.outputCounts[5]}
          </td>
     </tr>         
           
   </>
  }
}

export default AwardCountsByPlayer;